'use client';

import { useState, useEffect, useRef } from 'react';
import Icon from '@/components/ui/AppIcon';

interface Testimonial {
  id: string;
  text: string;
  memberName: string;
  designation: string;
  organization: string;
  image: string;
  background: string;
}

const testimonials: Testimonial[] = [
  {
    id: '1',
    text: 'President',
    memberName: 'Vikram Bhanushali',
    designation: 'President- ICPA',
    organization: 'Skyi Fkur Biopolymers Pvt. Ltd.',
    image: '/testimonials/vikram.jpg',
    background:
      'A polymer technologist focused on certified compostable materials and bio-based formulations, driving credible adoption of sustainable material systems.',
  },
  {
    id: '2',
    text: 'Joint President',
    memberName: 'Stefan Barot',
    designation: 'President – Chemicals Division',
    organization: 'Balrampur Chini Mills',
    image: '/testimonials/stefan.jpg',
    background:
      'With over 35 years of experience across 7 countries, including leadership at BIOTEC (Germany). EMBA from IMD Switzerland with deep expertise in biopolymers and scalable innovation.',
  },
  {
    id: '3',
    text: 'Principal Advisor – ICPA',
    memberName: 'Dr. S.K.Nayak',
    designation: 'Principal Advisor',
    organization: 'Former DG – CIPET, Govt. of India',
    image: '/testimonials/drnayak.jpeg',
    background:
      'Three decades of impact across research, training, and industry consulting, shaping India’s polymer ecosystem across academia, government, and industry.',
  },
   {
    id: '4',
    text: 'Secretary, ICPA',
    memberName: 'Dr. Sunder Balakrishnan',
    designation: 'General Manager',
    organization: 'Natur Tec India Pvt. Ltd.',
    image: '/testimonials/sb.jpg',
    background:
      'With deep expertise in biopolymers and compostable materials Mr. Balakrishnan brings over a decade of experience in biopolymers and compostable materials. He has led market development and commercialization of bio based, certified compostable solutions, helping scale sustainable alternatives to conventional plastics across diverse applications.',
  },
  
  {
    id: '5',
    text: 'Executive Committee Member',
    memberName: 'Mayur Mandhane',
    designation: 'Country Head – Petrochemicals',
    organization: 'TotalEnergies',
    image: '/testimonials/mayur.jpg',
    background:
      '20+ years in polymers and petrochemicals with P&L leadership, market development, and strong ethics-led growth across packaging, FMCG, and infrastructure.',
  },
  {
    id: '6',
    text: 'Executive Committee Member',
    memberName: 'Dr. S. Selvan',
    designation: 'Chief Manager – Corporate Strategy',
    organization: 'Former TNPCB Member Secretary',
    image: '/testimonials/selvan.jpg',
    background:
      'Dr. S. Selvan, former Member Secretary of TNPCB, is an environmental engineer and policy leader with over 35 years of experience in pollution control, environmental governance, industrial sustainability, regulatory reforms, and development of impactful policies promoting sustainable environmental practices and compliance.',
  },
  {
    id: '7',
    text: 'Chief Coordinator & Liaison Officer',
    memberName: 'Saurasanta Biswas',
    designation: 'Chief Coordinator & Liaison Officer',
    organization: 'ICPA',
    image: '/testimonials/saura.jpg',
    background:
      '17 years of experience supporting senior leadership. Brings strong governance coordination, execution discipline, and stakeholder management to ICPA.',
  },
];

const TestimonialsSection = () => {
  const itemsPerPage = 4;
  const totalPages = Math.ceil(testimonials.length / itemsPerPage);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const visibleTestimonials = testimonials.slice(
    currentIndex * itemsPerPage,
    currentIndex * itemsPerPage + itemsPerPage
  );

  // Auto-scroll logic
  useEffect(() => {
    if (isPaused) return;

    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev === totalPages - 1 ? 0 : prev + 1));
    }, 6000); // slow & calm

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isPaused, totalPages]);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? totalPages - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === totalPages - 1 ? 0 : prev + 1));
  };

  return (
    <section data-component-id="app/landing-page/components/TestimonialsSection.tsx:125:4" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="125" data-component-end-line="215" data-component-file="TestimonialsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22testimonials%22%2C%22className%22%3A%22py-20%20lg%3Apy-32%20bg-gradient-to-b%20from-white%20to-surface%22%7D"
      id="testimonials"
      className="py-20 lg:py-32 bg-gradient-to-b from-white to-surface"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div data-component-id="app/landing-page/components/TestimonialsSection.tsx:131:6" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="131" data-component-end-line="214" data-component-file="TestimonialsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%20lg%3Apx-8%22%7D" className="max-w-7xl mx-auto px-6 lg:px-8">
        <div data-component-id="app/landing-page/components/TestimonialsSection.tsx:132:8" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="132" data-component-end-line="136" data-component-file="TestimonialsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-16%22%7D" className="text-center mb-16">
          <h2 data-component-id="app/landing-page/components/TestimonialsSection.tsx:133:10" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="133" data-component-end-line="135" data-component-file="TestimonialsSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-satoshi%20font-bold%20text-3xl%20sm%3Atext-4xl%20lg%3Atext-5xl%20text-foreground%22%2C%22textContent%22%3A%22Team%20at%20ICPA%22%7D" className="font-satoshi font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground">
            Team at ICPA
          </h2>
        </div>

      <div data-component-id="app/landing-page/components/TestimonialsSection.tsx:138:6" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="138" data-component-end-line="179" data-component-file="TestimonialsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20xl%3Agrid-cols-4%20gap-6%20mb-12%20transition-opacity%20duration-500%22%7D" className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-12 transition-opacity duration-500">         
  {visibleTestimonials.map((testimonial) => (
            <div data-component-id="app/landing-page/components/TestimonialsSection.tsx:140:12" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="140" data-component-end-line="177" data-component-file="TestimonialsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-xl%20shadow-lg%20p-6%20border%20border-surface%20hover%3Aborder-primary%2F30%20transition-all%20duration-300%22%7D"
              key={testimonial.id}
              className="bg-card rounded-xl shadow-lg p-6 border border-surface hover:border-primary/30 transition-all duration-300"
            >
              <div data-component-id="app/landing-page/components/TestimonialsSection.tsx:144:14" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="144" data-component-end-line="164" data-component-file="TestimonialsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20gap-4%20mb-8%22%7D" className="flex items-start gap-4 mb-8">
                <div data-component-id="app/landing-page/components/TestimonialsSection.tsx:145:16" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="145" data-component-end-line="154" data-component-file="TestimonialsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-14%20h-14%20rounded-full%20overflow-hidden%20border%20border-border%20bg-surface%20flex-shrink-0%22%7D" className="w-14 h-14 rounded-full overflow-hidden border border-border bg-surface flex-shrink-0">
                  <img data-component-id="app/landing-page/components/TestimonialsSection.tsx:146:18" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="146" data-component-end-line="153" data-component-file="TestimonialsSection.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%22%7D"
                    src={testimonial.image}
                    alt={testimonial.memberName}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                    }}
                  />
                </div>

                <div data-component-id="app/landing-page/components/TestimonialsSection.tsx:156:16" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="156" data-component-end-line="163" data-component-file="TestimonialsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22pt-1%22%7D" className="pt-1">
                  <p data-component-id="app/landing-page/components/TestimonialsSection.tsx:157:18" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="157" data-component-end-line="159" data-component-file="TestimonialsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-satoshi%20font-semibold%20text-base%20text-foreground%22%7D" className="font-satoshi font-semibold text-base text-foreground">
                    {testimonial.memberName}
                  </p>
                  <p data-component-id="app/landing-page/components/TestimonialsSection.tsx:160:18" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="160" data-component-end-line="162" data-component-file="TestimonialsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-inter%20text-sm%20text-text-secondary%22%7D" className="font-inter text-sm text-text-secondary">
                    {testimonial.designation}
                  </p>
                </div>
              </div>

              <p data-component-id="app/landing-page/components/TestimonialsSection.tsx:166:14" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="166" data-component-end-line="168" data-component-file="TestimonialsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-inter%20font-medium%20text-foreground%20mb-4%22%2C%22textContent%22%3A%22%E2%80%9C%20%E2%80%9D%22%7D" className="font-inter font-medium text-foreground mb-4">
                “{testimonial.text}”
              </p>

              <p data-component-id="app/landing-page/components/TestimonialsSection.tsx:170:14" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="170" data-component-end-line="172" data-component-file="TestimonialsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-inter%20text-sm%20text-text-secondary%20leading-relaxed%20mb-6%22%7D" className="font-inter text-sm text-text-secondary leading-relaxed mb-6">
                {testimonial.background}
              </p>

              <p data-component-id="app/landing-page/components/TestimonialsSection.tsx:174:14" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="174" data-component-end-line="176" data-component-file="TestimonialsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-inter%20text-sm%20text-primary%20font-medium%22%7D" className="font-inter text-sm text-primary font-medium">
                {testimonial.organization}
              </p>
            </div>
          ))}
        </div>

        {/* Navigation */}
        <div data-component-id="app/landing-page/components/TestimonialsSection.tsx:182:8" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="182" data-component-end-line="213" data-component-file="TestimonialsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20gap-4%22%7D" className="flex items-center justify-center gap-4">
          <button data-component-id="app/landing-page/components/TestimonialsSection.tsx:183:10" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="183" data-component-end-line="189" data-component-file="TestimonialsSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-12%20h-12%20rounded-full%20bg-surface%20hover%3Abg-primary%2F10%20flex%20items-center%20justify-center%20transition-colors%22%7D"
            onClick={handlePrevious}
            className="w-12 h-12 rounded-full bg-surface hover:bg-primary/10 flex items-center justify-center transition-colors"
            aria-label="Previous testimonials"
          >
            <Icon data-component-id="app/landing-page/components/TestimonialsSection.tsx:188:12" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="188" data-component-end-line="188" data-component-file="TestimonialsSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChevronLeftIcon%22%2C%22className%22%3A%22text-foreground%22%7D" name="ChevronLeftIcon" size={24} className="text-foreground" />
          </button>

          <div data-component-id="app/landing-page/components/TestimonialsSection.tsx:191:10" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="191" data-component-end-line="204" data-component-file="TestimonialsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-2%22%7D" className="flex gap-2">
            {Array.from({ length: totalPages }).map((_, index) => (
              <button data-component-id="app/landing-page/components/TestimonialsSection.tsx:193:14" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="193" data-component-end-line="202" data-component-file="TestimonialsSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? 'bg-primary w-8'
                    : 'bg-surface w-2 hover:bg-primary/30'
                }`}
                aria-label={`Go to page ${index + 1}`}
              />
            ))}
          </div>

          <button data-component-id="app/landing-page/components/TestimonialsSection.tsx:206:10" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="206" data-component-end-line="212" data-component-file="TestimonialsSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-12%20h-12%20rounded-full%20bg-surface%20hover%3Abg-primary%2F10%20flex%20items-center%20justify-center%20transition-colors%22%7D"
            onClick={handleNext}
            className="w-12 h-12 rounded-full bg-surface hover:bg-primary/10 flex items-center justify-center transition-colors"
            aria-label="Next testimonials"
          >
            <Icon data-component-id="app/landing-page/components/TestimonialsSection.tsx:211:12" data-component-path="app/landing-page/components/TestimonialsSection.tsx" data-component-line="211" data-component-end-line="211" data-component-file="TestimonialsSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChevronRightIcon%22%2C%22className%22%3A%22text-foreground%22%7D" name="ChevronRightIcon" size={24} className="text-foreground" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;







